import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { dateFormat } from 'utils';
import { Notice } from './ui';

export default function AcceptEdit({ time, projectId, removeEdit }) {
  return (
    <Notice
      tone="erfolg"
      title="Deine Änderungen wurden freigegeben"
      onClose={() => removeEdit(projectId)}
    >
      Eingereicht am {moment.unix(time).format(dateFormat)}. Sie sind jetzt auf
      der Projektseite sichtbar.
    </Notice>
  );
}

AcceptEdit.propTypes = {
  time: PropTypes.number.isRequired,
  projectId: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
    .isRequired,
  removeEdit: PropTypes.func.isRequired,
};
